<template>
  <q-expansion-item
    v-model="isOpen"
    bordered
    default-closed
    switch-toggle-side
    class="bg-white rounded-borders"
    expand-icon-class="text-black"
    expand-icon="arrow_drop_up"
    :label="name"
    :header-inset-level="level"
    @click.native.stop="handleOpen"
  >
    <template v-slot:header>
      <q-item-section class="q-py-md">
        {{ nameOrPath }}
      </q-item-section>
      <q-checkbox
        v-if="selectable"
        :value="selected"
        color="green-4"
        class="q-my-sm"
        @input="onSelection"
      />
      <q-btn
        v-if="enableChanges"
        :ripple="false"
        class="q-ma-sm"
        flat
        @click.native.stop="() => showOptions = true"
      >
        <q-menu v-if="!readOnly">
          <q-list style="min-width: 210px">
            <q-item
              clickable
              @click.native.stop="addTopicChild"
            >
              <q-item-section>Adicionar subnível</q-item-section>
            </q-item>
            <q-item
              clickable
              @click.native.stop="renameTopic"
            >
              <q-item-section>Renomear</q-item-section>
            </q-item>
            <q-separator />
            <q-item
              class="text-red text-weight-bold"
              clickable
              @click.native.stop="deleteTopic"
            >
              <q-item-section>Deletar</q-item-section>
            </q-item>
          </q-list>
        </q-menu>
        <q-icon
          name="more_vert"
          size="30px"
        />
      </q-btn>
    </template>
    <div
      v-for="child in children"
      :key="child.id"
      class="q-ml-md"
    >
      <TopicTreeItem
        v-if="!loading && isOpen"
        :id="child.id"
        :on-change="onChangeHandler"
        :name="child.name"
        :has-children="child.has_children"
        :level="level + 1"
        :read-only="readOnly"
        :selection="selection"
        :selectable="selectable"
        :on-selection-change="handleSelection"
      />
      <q-spinner
        v-if="loading"
        class="q-ma-sm"
        style="min-width: 62px; min-height: 38;"
        color="primary"
        size="1rem"
        :thickness="2"
      />
    </div>
    <q-dialog
      v-model="renameDialog"
      persistent
    >
      <q-card class="column dialog-card">
        <div class="text-h6 q-pa-md">
          Editar matéria
        </div>
        <q-card-section
          class="full-width"
        >
          <div class="text-grey-7">
            Nome completo da matéria
          </div>
          <q-input
            ref="input"
            v-model="newName"
            :rules="[notEmpty]"
            dense
            filled
          />
        </q-card-section>

        <q-card-actions class="text-primary row justify-end q-mb-sm">
          <q-btn
            outline
            label="Cancelar"
            @click.native="() => renameDialog = false"
          />
          <q-btn
            outline
            label="Salvar"
            @click.native="onRenameOK"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog
      v-model="newChildDialog"
      persistent
    >
      <q-card class="column dialog-card">
        <div class="text-h6 q-pa-md">
          Adicionar matéria
        </div>
        <q-card-section
          class="full-width"
        >
          <div class="text-grey-7">
            Nome completo da matéria
          </div>
          <q-input
            ref="input"
            v-model="newChildName"
            :rules="[notEmpty]"
            dense
            filled
          />
        </q-card-section>

        <q-card-actions class="text-primary row justify-end q-mb-sm">
          <q-btn
            outline
            label="Cancelar"
            @click.native="() => newChildDialog = false"
          />
          <q-btn
            outline
            label="Salvar"
            @click.native="onNewChildOk"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-expansion-item>
</template>

<script>
import { notEmpty } from '@/utils/validators';
import { verticalsInSyncCatalogs } from '@/utils/verticals_in_sync_catalogs';

export default {
  name: 'TopicTreeItem',
  components: {
  },
  props: {
    id: { type: String, default: '' },
    name: { type: String, default: '' },
    hasChildren: { type: Boolean, default: false },
    level: { type: Number, default: 0 },
    onChange: { type: Function, default: () => {} },
    path: { type: String, default: '' },
    readOnly: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false },
    selection: { type: Array, default: () => [] },
    onSelectionChange: { type: Function, default: () => [] },
  },
  data: () => ({
    children: [],
    loading: false,
    renameDialog: false,
    newChildDialog: false,
    newName: '',
    newChildName: '',
    isOpen: false,
  }),
  computed: {
    enableChanges() {
      return !this.loading && !this.readOnly && !verticalsInSyncCatalogs.includes(sessionStorage.getItem('vertical'));
    },
    nameOrPath() {
      if (this.path !== '') {
        return this.path.split('[$$]').join(' / ');
      }
      return this.name;
    },
    selected() {
      return !!this.selection.find((t) => t.id === this.id);
    },
  },
  methods: {
    notEmpty,
    async readChildren() {
      this.children = await this.$services.topicsrest.readAllChildren(this.id);
    },
    async handleOpen() {
      if (this.children.length > 0) {
        return;
      }

      this.loading = true;
      if (this.hasChildren) {
        await this.readChildren();
      }
      this.loading = false;
    },
    async addTopicChild() {
      this.newChildDialog = true;
    },
    async onNewChildOk() {
      this.newChildDialog = false;
      await this.$services.topicsrest.createTopic(this.id, this.newChildName);
      await this.readChildren();
      this.isOpen = true;
      this.newChildName = '';
      this.$q.notify('Cadastrado com sucesso!');
    },
    async renameTopic() {
      this.newName = this.name;
      this.renameDialog = true;
    },
    async onRenameOK() {
      this.renameDialog = false;
      await this.$services.topicsrest.rename(this.id, this.newName);
      this.$q.notify('Renomeado com sucesso!');
      this.onChange();
    },
    async deleteTopic() {
      this.$q.dialog({
        title: 'Confirmação',
        message: `Deseja deletar "${this.name}"`,
        cancel: true,
        persistent: true,
      }).onOk(async () => {
        await this.$services.topicsrest.delete(this.id);
        this.$q.notify(`"${this.name}" deletado com sucesso!`);
        await this.readChildren();
        this.onChange();
      });
    },
    async onChangeHandler() {
      this.readChildren();
    },
    async handleSelection(topic, selected) {
      this.onSelectionChange(topic, selected);
    },
    async onSelection(v) {
      this.onSelectionChange({
        id: this.id,
        name: this.name,
        path: this.path,
      }, v);
    },
  },
};
</script>
